import React from 'react';
import { createRoot } from 'react-dom/client';
import PropertyCalendar from './PropertyCalendar.jsx';
import HomeSearch from './HomeSearch.jsx';
import SearchResults from './SearchResults.jsx';

function mountPropertyCalendar(el) {
  const form = el.closest('.book-form');
  if (form) form.classList.add('shs-calendar-active');
  const root = createRoot(el);
  root.render(
    <PropertyCalendar
      slug={el.dataset.slug}
      initialCheckIn={el.dataset.checkIn || ''}
      initialCheckOut={el.dataset.checkOut || ''}
      title={el.dataset.title || 'Select dates'}
      doneLabel={el.dataset.doneLabel || 'Save dates'}
    />
  );
}

function mountHomeSearch(el) {
  const form = el.closest('form');
  if (form) form.classList.add('shs-calendar-active');
  const root = createRoot(el);
  root.render(<HomeSearch form={form} />);
}

function mountSearchResults(el) {
  let homes = [];
  try {
    homes = JSON.parse(document.getElementById('shs-homes-data').textContent);
  } catch (e) {
    return; // leave the server-rendered noscript fallback in place
  }
  const root = createRoot(el);
  root.render(<SearchResults homes={homes} />);
}

function init() {
  document.querySelectorAll('[data-shs-calendar="property"]').forEach(mountPropertyCalendar);
  document.querySelectorAll('[data-shs-search="home"]').forEach(mountHomeSearch);
  document.querySelectorAll('[data-shs-search-results]').forEach(mountSearchResults);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
